/* Session 
- user 
- channel 
- qNode? 
- tags:TaskType [
    "sales", "get gate code"
]
- relation, to many: Task 

*/
import { Channel } from "../Com/Com.Interfaces";
import { EscalationErrorType, EscalationInterface, EscalationStatus } from "../Escalations/Escalations.Interface";
import { OrgBaseInterface } from "../Shared/OrgBase.Interace";
import { UserInterface } from "../User/User.Interface";
import { CallInterface } from "../Voice/Call.Interface";
import { TwilioCallStatus } from "../Voice/Twilio.Interface";

//LINK - libs/entities/src/Session/Session.Entity.ts
export interface SessionInterface extends OrgBaseInterface {
  // Backed by DB and Redis
  orgId: number; // This is the org ID, not the user ID.
  userId: number;
  user?: UserInterface;
  channel: Channel;
  open?: boolean; // This is the session status, if it's open or not.
  escalationId?: number; // This is the escalation ID, not the escalation object.
  escalation?: EscalationInterface;
  escalations?: EscalationInterface[];
  calls?: CallInterface[]; // All calls related to this session
  updatedAt: Date; // This is the last time the session was updated, not the escalation.
  qNode?: string; // Updates to this do NOT trigger a save.
  userMessageCount: number; // Auto increment.
  tags: string[]; // Tags for the session, like "sales", "get gate code", etc.
  callSid?: string; // This is the call SID for voice sessions.
  callStatus?: TwilioCallStatus; // This is the status for the call.
  url?: string; // This is the URL for the session, used for web sessions.
  lastUserMessage?: string;
  lastUserMessageAt?: Date; // This is the time the last message was sent in the session.
  merged?: { into?: number; from?: number }; // This is the user ID of the user we merged from, if any.
  breadcrumbs?: SessionBreadcrumbInterface[]; // This is the breadcrumb trail for the session, used for navigation.
  version: number;
  questContextId?: number;
}
export interface SessionBreadcrumbInterface {
  sideQuestSlug: string;
  parentQuestSlug: string;
  parentQuestNodeId: string;
  createdAt: string;
}

export function IsSessionTakenOver(session?: SessionInterface, byMemberId?: number): boolean {
  if (session && session?.escalation?.status == EscalationStatus.ACTIVE) {
    if (byMemberId) {
      return session.escalation?.assignedMemberId === byMemberId;
    }
    return true;
  }
  return false;
}

export function DoesSessionHaveActiveEscalation(session?: SessionInterface): boolean {
  if (
    session &&
    !session.escalation?.resolved &&
    session?.escalation?.status &&
    [EscalationStatus.PENDING, EscalationStatus.ASSIGNED, EscalationStatus.ACTIVE].includes(session?.escalation?.status)
  ) {
    return true;
  }
  return false;
}

// export interface ClientSessionInterface {

//   id: number; // This is the session ID.
//   updatedAt: Date; // This is the time the escalation was last updated.

//   // Backed by DB, sent any time ANYTHING changes.
//   channel: Channel;
//   userId: number;
//   escalationId?: number; // This is the escalation ID, not the escalation object.
//   escalation?: ClientEscalationInterface;
//   active?: boolean; // I also think we could send a timestamp here, and have the frontend decide the criteria.
//   // I active / not active is nice in that we dont need to constantly send a new pulse when the time stamp changes. Only on toggle.
//   userMessageNumber?: number;
//   lastUserMessage?: string;

//   lastUserMessageAt?: Date; // This is the time the last message was sent in the session.

//   tags: string[]; // Tags for the session, like "sales", "get gate code", etc.
//   pulseNumber?: number; // this is the number of messages sent in the session, not the escalation.
// }

// export interface ClientEscalationInterface {
//   id: number; // This is the escalation ID.
//   userId: number; // This is the user ID, not the escalation ID.
//   escalationGroupName: string; // This is the name of the escalation group, like "Sales", "Support", etc.
//   createdAt?: Date; // This is the time the escalation was created.
//   updatedAt: Date; // This is the time the escalation was last updated.
//   status: string; // Todo EscalationStatus?
//   agentName?: string;
//   searchingForNextAgentAt?: Date; // When we started looking for the next agent.
//   // this will be a stripped down version of the escalation for the front end.
// }
